const userTags = {
    '0x010461c14e146ac35fe42271bdc1134ee31c703a': 'HLP', 
    '0x2e3d94f0562703b25c83308a05046ddaf9a8dd14': 'HLP', 
    '0x31ca8395cf837de08b24da3f660e77761dfb974b': 'HLP',
    '0x8bf3ac5c417624b3bde7901de3c4ad7659599060': 'loracle.eth',
    '0x0856a8e260d6189B8560F734E5E3C99208C86554': 'loracle.eth',
}

export { userTags }